import React from 'react';
import { ArrowCounterClockwise, Prohibit, Trash } from '@phosphor-icons/react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { fmtDate } from './utils';

export const UsersTab = ({ users, onRevoke, onReactivate, onDelete, onRoleChange, currentUserId }) => {
  if (users.length === 0) {
    return <div className="card" style={{ padding: '32px', textAlign: 'center', color: '#5E5F66' }}>Aucun utilisateur</div>;
  }
  return (
    <div className="card" style={{ overflow: 'auto' }}>
      <table className="data-table" data-testid="users-access-table">
        <thead><tr><th>Nom</th><th>Email</th><th>Role</th><th>Derniere connexion</th><th>Statut</th><th>Actions</th></tr></thead>
        <tbody>
          {users.map(u => {
            const isDisabled = u.disabled;
            const notApproved = u.role === 'employee' && !u.approved;
            const isSelf = u.id === currentUserId;
            let badge = { bg: '#E8F5E9', color: '#2E7D32', label: 'Actif' };
            if (isDisabled) badge = { bg: '#FFEBEE', color: '#C62828', label: 'Revoque' };
            else if (notApproved) badge = { bg: '#FFF3E0', color: '#EF6C00', label: 'En attente' };
            return (
              <tr key={u.id} data-testid={`user-row-${u.id}`}>
                <td style={{ fontWeight: '600' }}>{u.name}</td>
                <td>{u.email}</td>
                <td>
                  <Select value={u.role} onValueChange={(v) => onRoleChange(u.id, u.name, v)} disabled={isSelf}>
                    <SelectTrigger style={{ height: '28px', fontSize: '0.8rem', minWidth: '130px', backgroundColor: u.role === 'admin' ? '#E3F2FD' : '#F4F5F7', color: u.role === 'admin' ? '#1565C0' : '#5E5F66', fontWeight: '600' }} data-testid={`role-select-${u.id}`}>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent className="z-[9999]">
                      <SelectItem value="employee">Salarie</SelectItem>
                      <SelectItem value="admin">Administrateur</SelectItem>
                    </SelectContent>
                  </Select>
                </td>
                <td style={{ fontSize: '0.8rem', color: '#5E5F66' }}>{fmtDate(u.last_login_at)}</td>
                <td><span style={{ padding: '3px 10px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: '600', backgroundColor: badge.bg, color: badge.color }}>{badge.label}</span></td>
                <td>
                  <div style={{ display: 'flex', gap: '4px' }}>
                    {isDisabled ? (
                      <button className="btn btn-secondary btn-sm" onClick={() => onReactivate(u.id, u.name)} title="Reactiver" data-testid={`reactivate-${u.id}`}><ArrowCounterClockwise size={14} /></button>
                    ) : (
                      <button className="btn btn-secondary btn-sm" onClick={() => onRevoke(u.id, u.name)} title="Revoquer l'acces" data-testid={`revoke-${u.id}`}><Prohibit size={14} /></button>
                    )}
                    <button className="btn btn-danger btn-sm" onClick={() => onDelete(u.id, u.name)} title="Supprimer definitivement" data-testid={`delete-${u.id}`}><Trash size={14} /></button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
